import { Component as BaseComponent, h } from 'preact';
import { connect } from 'preact-redux';

class Component extends BaseComponent {
    constructor() {
        super();

        this.timer = null;


        this.recaptcha = {
            src: 'https://www.google.com/recaptcha/api.js?&onload=recaptchaLoaded&render=explicit',
            element: null,
            id: null,
            sitekey: '6Lel5kwUAAAAAAdP-4POyS9jTX8FaSiMUsxdOQRP',
            loaded: false,
        };

        this.baseProps = {
            theme: 'light',
            type: 'image',
            tabindex: 0,
            size: 'normal',
            badge: 'bottomright',
        };
    }

    componentDidMount() {
        this.initialize();
    }

    componentWillUnmount() {
        this.clearTimer();

        if (this.recaptcha.loaded && this.recaptcha.element && this.recaptcha.id !== null) {
            this.remove();
        }

        window.___grecaptcha_cfg.count = 0;
        window.___grecaptcha_cfg.clients = {};
    }

    render() {
        const props = {
            ...this.props,
            ...this.baseProps,
        };

        return (
            <recaptcha>
                <div {...props} sitekey={this.recaptcha.sitekey} ref={this.capture} />
            </recaptcha>
        );
    }

    isLoaded = () => {
        return typeof window !== 'undefined' && typeof window.grecaptcha !== 'undefined';
    }

    isInjected = () => {
        if (typeof window === 'undefined') {
            return false;
        }

        if (!document.scripts || document.scripts.length === 0) {
            return false;
        }

        const scripts = Object.assign([], document.scripts).filter(script => {
            return script.src.match(/http(s)?:\/\/(www\.)?google\.com\/recaptcha\/api.js.*/i) !== null;
        });

        return scripts.length > 0;
    }

    capture = (elem) => {
        this.recaptcha.element = elem;
    }

    initialize = () => {
        if (this.isLoaded()) {
            this.recaptcha.loaded = true;
            this.clearTimer();
            this.renderRecaptcha();
        } else if (!this.isInjected()) {
            const script = document.createElement('script');

            window.recaptchaLoaded = this.initialize;

            script.src = this.recaptcha.src;
            script.async = 1;
            script.defer = 1;

            document.body.appendChild(script);
        } else {
            this.startTimer();
        }
    }

    renderRecaptcha = () => {
        if (this.props.size === 'invisible') {
            this.recaptcha.id = window.grecaptcha.render(this.recaptcha.element, {
                sitekey: this.recaptcha.sitekey,
                callback: this.handleChange,
                size: 'invisible',
            });
        } else {
            this.recaptcha.id = window.grecaptcha.render(this.recaptcha.element, {
                'sitekey': this.recaptcha.sitekey,
                'callback': this.handleChange,
                'expired-callback': this.handleExpired,
            });
        }
    }

    remove = () => {
        window.grecaptcha.reset(this.recaptcha.id);
    }

    execute = () => {
        if (this.recaptcha.loaded && this.recaptcha.element && this.recaptcha.id !== null) {
            window.grecaptcha.execute(this.recaptcha.id);
            return true;
        }

        return false;
    }

    reset = () => {
        if (this.recaptcha.loaded && this.recaptcha.element && this.recaptcha.id !== null) {
            window.grecaptcha.reset(this.recaptcha.id);
            return true;
        }

        return false;
    }

    handleExpired = () => {
        if (this.props.onExpired) {
            this.props.onExpired();
        }
    }

    handleChange = (response) => {
        if (this.props.onChange) {
            this.props.onChange(response);
        }
    }

    startTimer = () => {
        this.timer = setTimeout(this.initialize, 200000);
    }

    clearTimer = () => {
        if (this.timer !== null) {
            clearInterval(this.timer);
        }
    }

    getResponse = () => {
        if (this.recaptcha.loaded && this.recaptcha.element && this.recaptcha.id !== null) {
            return window.grecaptcha.getResponse(this.recaptcha.id);
        }

        return null;
    }
}

export default connect()(Component);



// WEBPACK FOOTER //
// ./app/components/recaptcha.js